<template>
  <div class="pit">
    <img :src="img[mouduleName]" alt />
    <div class="shop" v-if="mouduleName == 'pdd_module'||mouduleName =='jd_module'">
      <span class="title">{{info.items[0].title}}</span>
      <span class="subtitle">{{info.items[0].subTitle}}</span>
    </div>
    <mask-btn-group
      @moveUp="$emit('moveUp',idx)"
      @moveDown="$emit('moveDown',idx)"
      @edit="$emit('edit',idx)"
      @del="$emit('del',idx)"
      :info="info"
      :idx="idx"
      :moduleLength="moduleLength"
      :hasRecommend="hasRecommend"
    ></mask-btn-group>
  </div>
</template>

<script>
import search_module from '@imgs/search_module.png';
import banner_module from '@imgs/banner_module.png';
import command_module from '@imgs/command_module.png';
import sale_module from '@imgs/sale_module.png';
import pdd_module from '@imgs/pdd_module.png';
import jd_module from '@imgs/jd_module.png';
import maskBtnGroup from './maskBtnGroup';
export default {
  components: {
    maskBtnGroup,
  },
  props: {
    idx: [String, Number],
    info: Object,
    moduleLength: [String, Number],
    mouduleName: {
      type: String,
      default: '',
    },
    hasRecommend: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    img: {
      search_module,
      banner_module,
      command_module,
      sale_module,
      pdd_module,
      jd_module,
    },
  }),
};
</script>

<style lang="scss" scoped>
img {
  width: 100%;
  height: 100%;
}
.pit {
  position: relative;
  .shop {
    color: #fff;

    .title {
      position: absolute;
      top: 27px;
      left: 88px;
      font-size: 16px;
      font-weight: 600;
      line-height: 22px;
    }
    .subtitle {
      position: absolute;
      top: 30px;
      right: 40px;
      font-size: 12px;
      font-weight: 600;
      line-height: 17px;
    }
  }
}
</style>